import { API_ENDPOINT } from './api-config';

export const books = `${API_ENDPOINT}/book`;
export const manageBooks = `${API_ENDPOINT}/manage`;
export const instances = `${API_ENDPOINT}/instance`;
export const profile = `${API_ENDPOINT}/profile`;
export const myBooks = `${API_ENDPOINT}/mybooks`;

export const gitlab = {
  avatar: 'https://gitlab.autonomia.digital/api/v4/avatar',
};
